export type VoiceTurnIntent = 'interest' | 'objection' | 'no_time' | 'wrong_person' | 'question' | 'rejection' | 'unclear';

export const classifyVoiceTurn = (text: string): VoiceTurnIntent => {
  const normalized = text.toLowerCase();
  if (/geen interesse|niet geinteresseerd|niet geïnteresseerd|stop maar|laat maar/i.test(normalized)) return 'rejection';
  if (/geen tijd|druk|bel later|komt niet uit|nu niet/i.test(normalized)) return 'no_time';
  if (/verkeerde persoon|juiste persoon|niet verantwoordelijk|collega|iemand anders/i.test(normalized)) return 'wrong_person';
  if (/\?|wat bedoel|hoe werkt|waarom|welke|kunt u/i.test(normalized)) return 'question';
  if (/te duur|geen budget|al voorzien|hebben al|stuur maar|mail maar/i.test(normalized)) return 'objection';
  if (/ja|interessant|vertel|oké|oke|prima|kan/i.test(normalized)) return 'interest';
  return 'unclear';
};

export const sanitizeSpokenReply = (text: string) => {
  const withoutLabels = String(text || '')
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/^\s*(BDAT|MODEL|AGENT|ASSISTANT|Steve BDAT|Linda BDAT)\s*:\s*/gim, '')
    .replace(/\*\*/g, '')
    .replace(/[#*_`>-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^["']+|["']+$/g, '');

  const sentences = withoutLabels
    .split(/(?<=[.!?])\s+/)
    .map((item) => item.trim())
    .filter(Boolean)
    .slice(0, 2);

  return sentences.join(' ').trim();
};

export const hasUnsafeVoiceReply = (text: string) => {
  const normalized = text.toLowerCase();
  return [
    /ik ben jody/,
    /mede[- ]eigenaar/,
    /eigenaar van uw bedrijf/,
    /ik werk voor jullie/,
    /namens jullie bedrijf/,
    /strategic approach/,
    /interne redenering/,
    /analyse:/,
    /stap \d/,
  ].some((pattern) => pattern.test(normalized));
};

export const validateSpokenReply = (text: string) => {
  const cleaned = sanitizeSpokenReply(text);
  if (!cleaned) return { ok: false, text: '', reason: 'Geen spreektekst.' };
  if (hasUnsafeVoiceReply(cleaned)) return { ok: false, text: cleaned, reason: 'Onveilige of interne tekst.' };
  if (cleaned.length > 260) return { ok: false, text: cleaned.slice(0, 260), reason: 'Reactie is te lang.' };
  return { ok: true, text: cleaned, reason: '' };
};
